import React from 'react';
import { useIntl } from 'react-intl';
import type { ArtistProfileResponse } from 'fym-shared/src/music24/artistProfile';
import { TypedMemo } from '../../../../common/types';
import { spotifyBioUploadState } from './spotifyBioState';
import { spotifyBioMessages as s } from './spotifyBioMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the Profile; each part uses its own slice of it */
import styles from '../Profile.module.scss';
/* eslint-enable css-modules/no-unused-class */

/** The last bio upload: "Bio on Spotify since …", "You changed the bio after …", or nothing. */
const SpotifyBioStateLineComponent: React.FC<{ profile: Pick<ArtistProfileResponse, 'spotify'> }> = ({ profile }) => {
  const intl = useIntl();
  const state = spotifyBioUploadState(profile);
  if (state.kind === 'none') {
    return null;
  }
  const date = intl.formatDate(state.at, { day: 'numeric', month: 'short' });
  return (
    <span className={styles.meta} data-testid="spotify-bio-state" data-state={state.kind}>
      {intl.formatMessage(state.kind === 'onSpotify' ? s.onSince : s.changedSince, { date })}
    </span>
  );
};

export const SpotifyBioStateLine = TypedMemo(SpotifyBioStateLineComponent);
